export const sap2Society = {
  "0001": "CEPSA",
  "0006": "CEPSA AVIACIÓN S.A.",
  "0009": "CEPSA EP, S.A.U",
  "0011": "CEPSA BIOENERGIA S.ROQUE",
  "0012": "CEDIPSA",
  "0021": "PETROCAN",
  "0022": "CEPSA FINANCE, S.A.U.",
  "0025": "FUNDACIÓN CEPSA",
  "0032": "CEPSA GLOBAL SERVICES SA",
  "0036": "OLECASA",
  "0050": "CMD AEROPUERTOS CANARIOS",
  "0051": "CPP, S.A.",
  "0053": "CEPSA UK, LTD.",
  "0060": "CEPSA GAS LICUADO, S.A.",
  "0068": "PROPEL",
  "0093": "CEPSA GAS Y ELECTRICIDAD",
  "1024": "CEPSA COMERCIAL PETRÓLEO",
  "00B7": "CEPSA MARINE FUELS DMCC",
  "00D7": "RESSA",
  "00F3": "CEPSA ITALIA, S.P.A.",
  "00H6": "SEDAESAU",
  "00J9": "CEPSA EP ESPAÑA SL",
  "00K3": "GENER.ELECT.PENINSULAR SA",
  "00K8": "SPANISH INTOPLANE SERVICE",
  "00L6": "CEPSA TRADING, S.A.U",
  "00L9": "CEPSA BUSINESS SERVICES",
  "00Q8": "CEPSA QUIMICA,S.A.",
  "00R1": "ATLAS S.A.",
  "00R3": "SERVICAR",
  "00S0": "PETRONUBA S.A.U",
  "00S6": "CEPSA GAS COMERCIALIZADOR",
  "00T7": "CEPSA COLOMBIA, SA"
};

export const society2Sap = {
  CEPSA: "0001",
  "CEPSA AVIACIÓN S.A.": "0006",
  "CEPSA EP, S.A.U": "0009",
  "CEPSA BIOENERGIA S.ROQUE": "0011",
  CEDIPSA: "0012",
  PETROCAN: "0021",
  "CEPSA FINANCE, S.A.U.": "0022",
  "FUNDACIÓN CEPSA": "0025",
  "CEPSA GLOBAL SERVICES SA": "0032",
  OLECASA: "0036",
  "CMD AEROPUERTOS CANARIOS": "0050",
  "CPP, S.A.": "0051",
  "CEPSA UK, LTD.": "0053",
  "CEPSA GAS LICUADO, S.A.": "0060",
  PROPEL: "0068",
  "CEPSA GAS Y ELECTRICIDAD": "0093",
  "CEPSA COMERCIAL PETRÓLEO": "1024",
  "CEPSA MARINE FUELS DMCC": "00B7",
  RESSA: "00D7",
  "CEPSA ITALIA, S.P.A.": "00F3",
  SEDAESAU: "00H6",
  "CEPSA EP ESPAÑA SL": "00J9",
  "GENER.ELECT.PENINSULAR SA": "00K3",
  "SPANISH INTOPLANE SERVICE": "00K8",
  "CEPSA TRADING, S.A.U": "00L6",
  "CEPSA BUSINESS SERVICES": "00L9",
  "CEPSA QUIMICA,S.A.": "00Q8",
  "ATLAS S.A.": "00R1",
  SERVICAR: "00R3",
  "PETRONUBA S.A.U": "00S0",
  "CEPSA GAS COMERCIALIZADOR": "00S6",
  "CEPSA COLOMBIA, SA": "00T7"
};

export const sap2Division = {
  "0001": "Tenerife",
  "0002": "Algeciras",
  "0003": "Energéticos",
  "0004": "Bunker",
  "0005": "Aviación",
  "0006": "Lubricantes",
  "0007": "Asfaltos",
  "0008": "Aprovisionamiento / Transporte",
  "0009": "Huelva",
  "0010": "Gas Natural",
  "0011": "Electricidad",
  "0012": "Gas",
  "0014": "Red",
  "0015": "TIENDA",
  "0016": "Bio",
  "0017": "Renovables",
  "0101": "Petroquímicos",
  "0111": "Fenol / Acetona",
  "0112": "LAB / LAS",
  "0113": "PTA/PIA/PET",
  "0114": "Disolventes",
  "0115": "Intermedios",
  "0116": "Fatty Alcohols & Derivatives",
  "0201": "E & P",
  "0202": "E & P - Sucursal",
  "0300": "Trading",
  "1100": "Corporación"
};

export const division2Sap = {
  Tenerife: "0001",
  Algeciras: "0002",
  Energéticos: "0003",
  Bunker: "0004",
  Aviación: "0005",
  Lubricantes: "0006",
  Asfaltos: "0007",
  "Aprovisionamiento / Transporte": "0008",
  Huelva: "0009",
  "Gas Natural": "0010",
  Electricidad: "0011",
  Gas: "0012",
  Red: "0014",
  TIENDA: "0015",
  Bio: "0016",
  Renovables: "0017",
  Petroquímicos: "0101",
  "Fenol / Acetona": "0111",
  "LAB / LAS": "0112",
  "PTA/PIA/PET": "0113",
  Disolventes: "0114",
  Intermedios: "0115",
  "Fatty Alcohols & Derivatives": "0116",
  "E & P": "0201",
  "E & P - Sucursal": "0202",
  Trading: "0300",
  Corporación: "1100"
};

export const sap2AccountingKey = {
  "01": "FACTURA",
  "02": "ANULACIÓN FRA. NEGAT",
  "03": "OTROS CARGOS (SEOP)",
  "04": "OTR.CTAS.COB(RTRASP)",
  "05": "PAGOS.-COMP.PARTIDAS",
  "06": "IMPAGADOS",
  "07": "OTRAS COMPENSACIONES S",
  "08": "FACTURA INT. DEMORA",
  "09": 'CARGO "CME" DEUDORES',
  "10": "DIFERENCIAS EN COBRO S",
  "11": "FACTURA NEGATIVA",
  "12": "ANULACIÓN DE FACTURA",
  "13": "OTROS ABONOS (SEOP)",
  "14": "OTR.CTAS.PAG(RTRASP)",
  "15": "COBROS-COMP.PARTIDAS",
  "16": "ANULACIÓN IMPAGADO",
  "17": "OTRAS COMPENSACIONES H",
  "18": "FRA.NEG.-INT. DEMORA",
  "19": 'ABONO "CME" DEUDORES',
  "20": "DIFERENCIAS EN COBRO H",
  "28": "CARGO COMPENS. RESTO",
  "34": "NOTA DE CARGO (SEOP)",
  "35": "ENTRADA PAGOS",
  "36": "ABONO DIF.PAGO ACRE.",
  "38": "ABONO COMPENS. RESTO",
  "40": "CARGO A CTA. MAYOR",
  "50": "ABONO A CUENTA MAYOR",
  "61": "D.E.E.- Cargos",
  "62": "D.E.E.- Abonos"
};

export const accountingKey2Sap = {
  FACTURA: "01",
  "ANULACIÓN FRA. NEGAT": "02",
  "OTROS CARGOS (SEOP)": "03",
  "OTR.CTAS.COB(RTRASP)": "04",
  "PAGOS.-COMP.PARTIDAS": "05",
  IMPAGADOS: "06",
  "OTRAS COMPENSACIONES S": "07",
  "FACTURA INT. DEMORA": "08",
  'CARGO "CME" DEUDORES': "09",
  "DIFERENCIAS EN COBRO S": "10",
  "FACTURA NEGATIVA": "11",
  "ANULACIÓN DE FACTURA": "12",
  "OTROS ABONOS (SEOP)": "13",
  "OTR.CTAS.PAG(RTRASP)": "14",
  "COBROS-COMP.PARTIDAS": "15",
  "ANULACIÓN IMPAGADO": "16",
  "OTRAS COMPENSACIONES H": "17",
  "FRA.NEG.-INT. DEMORA": "18",
  'ABONO "CME" DEUDORES': "19",
  "DIFERENCIAS EN COBRO H": "20",
  "CARGO COMPENS. RESTO": "28",
  "NOTA DE CARGO (SEOP)": "34",
  "ENTRADA PAGOS": "35",
  "ABONO DIF.PAGO ACRE.": "36",
  "ABONO COMPENS. RESTO": "38",
  "CARGO A CTA. MAYOR": "40",
  "ABONO A CUENTA MAYOR": "50",
  "D.E.E.- Cargos": "61",
  "D.E.E.- Abonos": "62"
};

const negative = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "28", "40", "61"];
const negativeMajorAccounts = [
  "6591000000",
  "6591000001",
  "6260000001",
  "6260000003",
  "6988900000" // Añadido por Maria Elena (PORTUGAL)
];

export const accountingKeySign = accKey => {
  if (accKey && negative.includes(accKey)) return -1;
  return 1;
};

export const majorAccountSign = majorAccount => {
  if (majorAccount && negativeMajorAccounts.includes(majorAccount)) return -1;
  return 1;
};

export const sap2ClaimingArea = society => {
  if (society === "1024") {
    return {
      "10": "PUERTO ALICANTE",
      "11": "ATL Cataluña-Lubricantes",
      "12": "PUERTO CULLERA",
      "13": "PUERTO ADRA",
      "14": "PUERTO ROQUETAS DE MAR",
      "15": "PUERTO AYAMONTE",
      "16": "PUERTO HUELVA",
      "17": "PUERTO ESTEPONA",
      "18": "PUERTO MARBELLA",
      "19": "PUERTO BARBATE",
      "20": "PUERTO CADIZ",
      "21": "PUERTO SANLUCAR DE BARRAMEDA",
      "22": "P.P.ISLA CRISTINA",
      "23": "P.P.PUNTA UMBRIA",
      "24": "P.P.CONIL",
      "25": "P.P.TARIFA",
      "26": "P.P.ALGECIRAS",
      "27": "P.P.LA LINEA DE LA CONCEPCIÓN",
      "28": "P.P.EL SALADILLO",
      "29": "P.P.MALAGA",
      "30": "P.P.MOTRIL",
      "31": "P.P.ALMERIA",
      "32": "P.P.SAN PEDRO DEL PINATAR",
      "33": "P.P.TORREVIEJA",
      "34": "P.P.SANTA POLA",
      "35": "P.P.CALPE",
      "36": "P.P.MORAIRA",
      "37": "P.P.BARCELONA",
      "38": "ATL Andalucia Occidental",
      "39": "ATL Jaén",
      "40": "ATL Gestión Centralizada",
      "43": "P/P EXPLOTACIÓN",
      "44": "P/P GESTORES AJENOS",
      "45": "P.P. de POLLENSA",
      "46": "P.PUERTO DE.SANTA MARIA 2",
      "47": "P.P. Castellón",
      "48": "P.P.Barbate",
      "49": "P.P. ALMERIA",
      "51": "Canarias",
      "71": "Deudores no comerciales",
      "90": "Gestión Centralizada PP",
      "91": "Gestión Centralizada",
      "99": "COMA",
      "00": "ATL Levante-Lubricantes",
      "01": "ATL-Centro",
      "02": "ATL-Galicia",
      "03": "ATL-Asturias",
      "04": "ATL-Santander",
      "05": "ATL-Bilbao",
      "06": "ATL-Andalucia-Oriental",
      "07": "PUERTO MARÍN",
      "08": "PUERTO DENIA",
      "09": "PUERTO JAVEA",
      B0: "Postes Pesca",
      B1: "CGL ENVASADO CENTRO",
      B2: "CGL ENVASADO LEVANTE",
      B3: "CGL ENVASADO SUR",
      B4: "CGL ENVASADO NORTE",
      B5: "Envasado Canarias",
      BI: "Bilbao",
      C0: "CGL Levante (Canalizado)",
      C1: "CGL Centro (Canalizado)",
      C2: "CGL Castilla/León (Canalizado)",
      C3: "CGL Malaga (Canalizado)",
      C4: "CGL Granada (Canalizado)",
      C5: "CGL Sur (Canalizado)",
      C6: "CGL Norte (Canalizado)",
      C7: "CGL Cataluña (Canalizado)",
      C8: "CGL Aragón (Canalizado)",
      C9: "CGL Centro/Norte (Canalizado)",
      CA: "CGL Noroeste (Canalizado)",
      CI: "Clientes Institucionales",
      CN: "Centro-Norte",
      CS: "Centro-Sur",
      E0: "EESS CENTRALIZADA",
      E1: "EESS NORTE",
      E2: "EESS ESTE",
      E3: "EESS CENTRO",
      E4: "EESS SUR",
      E5: "EESS NOROESTE",
      E6: "EESS CANARIAS",
      EX: "Exportaciones",
      G0: "CGL GESTION CENTRALIZADA",
      G1: "CGL GRANEL CENTRO",
      G2: "CGL GRANEL LEVANTE",
      G3: "CGL GRANEL SUR",
      G4: "CGL GRANEL NORTE",
      G5: "CGL GRANEL CANARIAS",
      GI: "Gijon",
      L0: "LUBES ATLÁNTICO",
      L1: "LUB GENERAL: Gestion Centralizada",
      L2: "LUB EXPORTACION",
      L3: "LUB BASES",
      L4: "LUB ESTACIONES DE SERVICIO",
      L5: "LUB PARAFINAS",
      L6: "LUB EXPORTACION PORTUGAL",
      L7: "LUB CANARIAS ( Disa)",
      L8: "LUB DISTRIB. CEPSA",
      L9: "LUB BP",
      LA: "LUB MARINOS: Levante",
      LB: "LUB MARINOS: Noroeste",
      LC: "LUB MARINOS: Canarias",
      LD: "LUB MARINOS: Norte",
      LE: "LUB MARINOS: Centralizados",
      LF: "LUB MARINOS: Sur",
      LG: "LUB MARINOS: Exxon",
      LH: "LUB P.FLOTAS: Este",
      LI: "LUB P.FLOTAS: Centro",
      LJ: "LUB P.FLOTAS: Norte",
      LK: "LUB P.FLOTAS: Centralizados",
      LM: "LUB P.INDUSTRIA: Este",
      LN: "LUB P.INDUSTRIA: Centro",
      LO: "LUB P.INDUSTRIA: Norte",
      LP: "LUB P.INDUSTRIA: Centralizados",
      LQ: "LUB GRANDES SUPERFICIES",
      LR: "LUB CONSUMO",
      LS: "LUB RESTO CONSUMO",
      LT: "LUB MARCAS TERCERAS",
      LU: "LUB CHEVRON",
      LV: "LUB CARGA INICIAL CHEVRON",
      MA: "Madrid",
      MO: "Motril",
      NE: "Noreste",
      NO: "Norte",
      P1: "P.P CENTRAL MADRID",
      P2: "PUERTO STA. MARIA",
      P3: "PUERTO VINAROZ",
      P4: "PUERTO GIJON",
      P5: "PUERTO BERBES",
      P6: "FACTORIA GUIXAR",
      P7: "PUERTO SAGUNTO",
      P8: "bunker canarias",
      P9: "bunker sur",
      PA: "bunker este",
      PB: "bunker norte",
      PC: "Bunker centralizada",
      PD: "Aldesa-Torrevieja",
      SE: "Sevilla",
      SU: "Sur",
      TA: "Tarragona",
      VA: "Valencia",
      VD: "Ventas Directas Centralizadas",
      Ç1: "EESS CODO+ NORTE",
      Ç2: "EESS CODO+ ESTE",
      Ç3: "EESS CODO+ CENTRO", 
      Ç4: "EESS CODO+ SUR",
      Ç5: "EESS CODO+ NOROESTE",
      Ç6: "EESS CODO+ CANARIAS",
      Ç7: "EESS CODO+ NORESTE",
      Ç8: "EESS CODO+ CENTRO SUR"
    };
  }
  if (society === "0001") {
    return {
      "10": "10 Ventas",
      "11": "11 Bunker Tenerife",
      "12": "12 Bunker Sur",
      "13": "13 Bunker Este",
      "14": "14 Bunker Noroeste",
      "15": "15 Bunker Norte",
      "16": "16 Bunker Las Palmas",
      "17": "17 Bunker Centralizados",
      "18": "18 Bunker Suroeste",
      "19": "19 Bunker Postes Pesca",
      "20": "20 Bunker Ventas Directas",
      "21": "21 Bunker Gibraltar",
      "22": "22 Gibraltar",
      "23": "23 Gestión Centralizada",
      "24": "24 VD-REVENDEDORES-SUR",
      "25": "25 VD-REVENDEDORES-ESTE",
      "26": "26 VD-REVENDEDORES-NOROESTE",
      "27": "27 VD-REVENDEDORES-CENTRO",
      "28": "28 VD-REVENDEDORES-NORTE",
      "29": "29 VD-REVENDEDORES-NORESTE",
      "30": "30 VD-VALES COMBUSTIBLE",
      "31": "31 VD-CANARIAS",
      "32": "32 VD-CD-CEUTA/MELILLA",
      "33": "33 VD-EXPORTACIONES",
      "34": "34 EN-EXPORTACIONES",
      "35": "35 VD-CLIENTES DIRECTOS-SUR",
      "36": "36 VD-FILIALES",
      "37": "37 VD-GRANDES CLIENTES ESTRATÉGICOS",
      "38": "38 VD-CLIENTES DIRECTOS-ESTE",
      "39": "39 VD-CLIENTES DIRECTOS-NOROESTE",
      "40": "40 VD-CLIENTES DIRECTOS-CENTRO",
      "41": "41 VD-CLIENTES DIRECTOS-NORTE",
      "42": "42 VD-CLIENTES DIRECTOS-NORESTE",
      "43": "43 VD-OTRAS FILIALES",
      "44": "44 VD-CLIENTES DIRECTOS-ÁREAS FILIALES",
      "45": "45 VD-OPERADORES",
      "46": "46 VD-REVENDEDORES-ÁREAS FILIALES",
      "47": "47 EN-OPER.LOGÍSTICAS / INTERCAMBIOS",
      "48": "48 EN-ASFALTOS",
      "49": "49 EX-LUBRICANTES",
      "50": "Incidencias Distribución",
      "51": "Aviación General",
      "52": "Aviación Líneas",
      "53": "Aviación Militar",
      "54": "Aviación Petrolíferas",
      "55": "Aviación Revendedores",
      "56": "56 VD-EE.SS.Grandes Superficies",
      "57": "57 Bunker Madrid",
      "58": "58 Bunker Canarias",
      "59": "59 Bunker Sur/BK-Algeciras",
      "60": "60 Bunker Este/BK-Barcelona",
      "61": "61 Fletes y Demoras",
      "62": "62 Bunker Este/BK-Valencia",
      "63": "63 Bunker NORTE/BK-Bilbao",
      "64": "64 Bunker NORTE/BK-Vigo",
      "65": "65 EN-DES.NEG.EXPORTACIONES",
      "66": "66 VD-CLIENTES DIRECTOS-CEUTA/MELILLA",
      "67": "67 Gestión Centralizada (PP)",
      "68": "68 VD-GRANDES CLIENTES ESTRATEGICOS-8",
      "69": "69 VD-OTRAS FILIALES-8",
      "70": "70 VD-INSTITUCIONALES CENTRALIZADOS EXPEDIENTES",
      "71": "71 VD-INSTITUCIONALES DESCENTRALIZADOS-ESTE",
      "72": "72 VD-INSTITUCIONALES DESCENTRALIZADOS-NOROESTE",
      "73": "73 VD-INSTITUCIONALES DESCENTRALIZADOS-CENTRO",
      "74": "74 VD-INSTITUCIONALES DESCENTRALIZADOS-NORTE",
      "75": "75 VD-INSTITUCIONALES CENTRALIZADOS VARIOS",
      "76": "76 VD-INSTITUCIONALES DESCENTRALIZADOS-NORESTE",
      "77": "77 VD-INSTITUCIONALES DESCENTRALIZADOS-SUR",
      "78": "78 VD-INSTITUCIONALES DESCENTRALIZADOS-FILIALES",
      "79": "Institucionales Ceuta/Melilla (NO USAR) sólo infor",
      "80": "80 VD-CLIENTES DIRECTOS-ESTRATÉGICOS CENTRALIZADOS",
      "81": "81 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-ESTE",
      "82": "82 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-NOROESTE",
      "83": "83 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-CENTRO",
      "84": "84 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-NORTE",
      "85": "85 VD-CD-Estratégicos Canarias (ex-CCL)",
      "86": "86 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-NORESTE",
      "87": "87 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-SUR",
      "88": "88 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-FILIALES",
      "89": "89 VD-REVENDEDORES ESTRATÉGICOS CENTRALIZADOS",
      "90": "90 Gestión Corporativa",
      "91": "91 Gibraltar - San Roque",
      "92": "92 Tenerife",
      "93": "93 Exploración / Producción",
      "94": "94 Huelva",
      "95": "95 VD-EE.SS.Blancas",
      "96": "Planta de Cogeneración La Rábida",
      "97": "Gas",
      "98": "98 VD-OTRAS FILIALES-14",
      "99": "99 EN-OPER.LOGÍSTICAS / INTERCAMBIOS-8",
      "01": "Químicos Gestión Plastificantes",
      "02": "Químicos Este",
      "03": "Químicos Centro",
      "04": "Químicos Portugal",
      "05": "Químicos Noreste",
      "06": "Químicos Centralizados",
      "07": "Químicos Norte",
      "08": "Químicos; Huelva Nacional",
      "09": "Químicos; Huelva Exportación",
      A1: "Multiárea División 0001",
      A2: "Multiárea División 0002",
      A3: "Multiárea División 0003",
      A4: "Multiárea División 0004",
      A5: "Multiárea División 0005",
      A8: "Multiárea División 0008",
      A9: "Multiárea División 0009",
      AC: "Multiárea División 1100",
      AE: "Multiárea División 0201",
      AP: "Multiárea División 0101",
      B0: "Postes Pesca",
      B1: "B1 VD Exportaciones-8",
      B2: "B2 EN-EXPORTACIONES-8",
      B3: "B3 EN-ASFALTOS-7",
      B4: "Doméstico Zona Centro",
      B5: "Industria Zona Centro",
      B6: "Administraciones Públicas Zona Centro",
      B7: "Transporte Zona Centro",
      B8: "Agrícola Zona Centro",
      B9: "Descentralizados Filiales Zona Centro",
      C0: "lubrisur",
      C4: "VD - Doméstico Zona Noreste",
      C5: "VD - Industria Zona Noreste",
      C6: "VD - Administraciones Públicas Zona Noreste",
      C7: "VD - Transporte Zona Noreste",
      C8: "VD - Agrícola Zona Noreste",
      C9: "VD - Descentralizados Filiales Zona Noreste",
      CG: "Consignaciones",
      D4: "VD - Doméstico Zona Norte",
      D5: "VD - Industria Zona Norte",
      D6: "VD - Administraciones Públicas Zona Norte",
      D7: "VD - Transporte Zona Norte",
      D8: "VD - Agrícola Zona Norte",
      D9: "VD - Descentralizados Filiales Zona Norte",
      E4: "VD - Doméstico Zona Sur",
      E5: "VD - Industria Zona Sur",
      E6: "VD - Administraciones Públicas Zona Sur",
      E7: "VD - Transporte Zona Sur",
      E8: "VD - Agrícola Zona Sur",
      E9: "VD - Descentralizados Filiales Zona Sur",
      F1: "Trading",
      G1: "Cepsa Gibraltar",
      R0: "RED AAPP",
      R1: "Ressa Zona Sur",
      R2: "Ressa Zona Centro",
      R3: "Ressa Centralizados",
      R4: "Ressa Retail",
      R5: "Ressa Zona Este",
      R6: "Ressa Zona Noreste",
      R7: "Ressa Zona Noroeste",
      R8: "Ressa Zona Centro Norte",
      Y1: "EEBB D1",
      Y2: "EEBB D6",
      Y3: "EEBB D7",
      Y4: "EEBB D9",
      Y5: "EEBB_DH",
      Z1: "Energetico-BIO",
      T1: "TRANSPORTE ZONA SUR",
      T2: "TRANSPORTE ZONA CENTRO",
      T3: "TRANSPORTE ZONA NOROESTE",
      T4: "TRANSPORTE ZONA ESTE",
      T5: "TRANSPORTE CENTRALIZADOS"
    };
  }
  if (society === "00D7") {
    return {
      "20": "Clientes Pan Europe",
      "21": "Clientes NO Recibo Domiciliado",
      "22": "Clientes Devoluciones",
      "23": "Otros Clientes",
      "24": "Gestión Centralizada",
      "90": "Gestión Centralizada",
      "01": "Domiciliados",
      "02": "AA.PP y similares",
      "03": "Clientes Estratégicos",
      "04": "SECTRAM",
      "05": "Otros Emisores (Eurotrafic, Routex,...) ",
      "06": "Otros Suministradores (CPP, CEPSA, CES, ...)",
      "07": "Estaciones y otros Establecimientos (autopistas,.)",
      "08": "Portugal"
    };
  }
  if (society === "00Q8") {
    return {
      "10": "Europa comunitario",
      "11": "Portugal",
      "12": "Holanda",
      "13": "Reino Unido",
      "20": "Exportación",
      "40": "sin usoant. Quimica Otros",
      "50": "Operaciones NO comerciales",
      "01": "España",
      "02": "Este",
      "03": "sin usoant. Quimica Centro",
      "04": "Noreste",
      "05": "Norte"
    };
  }
  if (society === "0006") {
    return { "90": "Gestión Centralizada" };
  }
  if (society === "0009") {
    return { "90": "Gestión Centralizada" };
  }
  if (society === "0011") {
    return { "90": "Gestión Centralizada", B1: "Bio" };
  }
  if (society === "0021") {
    return { "90": "Gestión Centralizada" };
  }
  if (society === "0025") {
    return { "90": "Gestión Centralizada" };
  }
  if (society === "0032") {
    return { "90": "Gestión Centralizada" };
  }
  if (society === "0036") {
    return { "90": "Gestión Centralizada" };
  }
  if (society === "0050") {
    return { "90": "Gestión Centralizada" };
  }
  if (society === "0051") {
    return {
      AA: "VVDD - Aviação",
      AB: "AVIAÇAO - Revendedor",
      AC: "AVIAÇAO - Congénere",
      GA: "GPL - Cliente Directo",
      GB: "GPL - Revendedor",
      GC: "GPL - Cliente Premium",
      GE: "Gas Envasado",
      GU: "GAS NATURAL CENTRO NORTE COMERCIALIZADOR",
      GV: "GAS NATURAL CENTRO NORTE CLIENTE DIRETO",
      GW: "GAS NATURAL CENTRO SUL COMERCIALIZADOR",
      GX: "GAS NATURAL CENTRO SUL CLIENTE DIRETO",
      GY: "GAS NATURAL CHEFE NEGÓCIO COMERCIALIZADOR",
      GZ: "GAS NATURAL CHEFE NEGÓCIO CLIENTE DIRETO",
      IA: "Industria - Chefe Negócio Cliente Directo",
      IB: "Industria - Chefe Negócio Revendedor",
      IC: "Industria - Chefe Negócio Cogeraçao",
      ID: "Industria - Centro Sul Cliente Directo",
      IE: "Industria - Centro Sul Revendedor",
      IF: "Industria - Centro Sul Cogeraçao",
      IG: "Industria - Centro Norte Cliente Directo",
      IH: "Industria - Centro Norte Revendedor",
      II: "Industria - Centro Norte Cogeraçao",
      LA: "Conc.C",
      LB: "Conc.N",
      LC: "Conc.S",
      LD: "Rev.C",
      LE: "Rev.N",
      LF: "Rev.S",
      LG: "Rev. Sede",
      LJ: "Conc. Sede",
      LK: "Lubrificantes Profissional - Aviação",
      LL: "OP VD 4",
      LM: "Prof.C",
      LN: "Prof.N",
      LO: "Prof.S",
      LP: "Prof.Sede",
      LQ: "Internos",
      LR: "MKT",
      MA: "Marinha - Chefe Negócio Cliente Directo",
      MB: "Marinha - Chefe Negócio Congénere",
      MC: "Marinha - Chefe Negócio Revendedor",
      MD: "Marinha - Centro Sul Cliente Directo",
      ME: "Marinha - Centro Sul Congénere",
      MF: "Marinha - Centro Sul Revendedor",
      MG: "Marinha - Centro Norte Cliente Directo",
      MH: "Marinha - Centro Norte Congénere",
      MI: "Marinha - Centro Norte Revendedor",
      MJ: "Marinha - Paulo Moreira",
      MK: "Marinha - María José",
      OA: "OO.PP. - Chefe Negócio Cliente Directo",
      OB: "OO.PP. - Chefe Negócio Revendedor",
      OC: "OO.PP. - Chefe Negócio Congénere",
      OD: "OP VD 1",
      OE: "OO.PP. - Centro Norte Revendedor",
      OF: "OO.PP. - Centro Norte Congénere",
      OG: "OP VD 2",
      OH: "OO.PP. - Centro Sul Revendedor",
      OI: "OO.PP. - Centro Sul Congénere",
      OJ: "OP VD 3",
      OK: "OO.PP. - Ilhas",
      RA: "REDE - PROPEL",
      RB: "REDE - Interior Norte",
      RC: "REDE - Norte",
      RD: "REDE - Porto",
      RE: "REDE - Porto Norte",
      RF: "REDE - Lisboa Norte",
      RG: "REDE - Lisboa Sul",
      RH: "REDE - Centro",
      RI: "REDE - Sul",
      RJ: "REDE - Lojas",
      RK: "REDE - Restauración",
      TG: "Cartöes - Zona Centro",
      TH: "Cartöes - Zona Norte",
      TI: "Cartöes - Zona Sul",
      TJ: "Cartöes - Cessao de crédito",
      TX: "Cartöes - Cessao de crédito",
      VA: "Produtos Brancos - Chefe Negócio Cliente Directo",
      VB: "Produtos Brancos - Chefe Negócio Congénere",
      VC: "Produtos Brancos - Chefe Negócio Posto Branco",
      VD: "Produtos Brancos - Chefe Negócio Rede",
      VE: "Produtos Brancos - Chefe Negócio Revendedor",
      VF: "Produtos Brancos - Centro Norte Cliente Directo",
      VG: "Produtos Brancos - Centro Norte Posto Branco",
      VH: "Produtos Brancos - Centro Norte Rede",
      VI: "Produtos Brancos - Centro Norte Revendedor",
      VJ: "Produtos Brancos - Centro Sul Cliente Directo",
      VK: "Produtos Brancos - Centro Sul Posto Branco",
      VL: "Produtos Brancos - Centro Sul Rede",
      VM: "Produtos Brancos - Centro Sul Revendedor",
      VN: "Produtos Brancos - Norte Cliente Directo",
      VO: "Produtos Brancos - Norte Posto Branco",
      VP: "Produtos Brancos - Norte Rede",
      VQ: "Produtos Brancos - Norte Revendedor",
      VR: "Produtos Brancos - Revendedores",
      VS: "Produtos Brancos - Sul Cliente Directo",
      VT: "Produtos Brancos - Sul Posto Branco",
      VU: "Produtos Brancos - Sul Rede",
      VV: "Produtos Brancos - Sul Revendedor",
      VW: "Produtos Brancos - Ricardo Silveira",
      YY: "GESTAO-administraçao"
    };
  }
  if (society === "0093") {
    return {
      "11": "Comerc. Portugal",
      "98": "Trading",
      "99": "Cl. Institucionales",
      "01": "Comercializadora",
      "02": "Gas Natural",
      "03": "Agente A",
      "04": "Agente B",
      "05": "Agente C",
      "06": "CODO-DODO"
    };
  }
  if (society === "00H6") {
    return { "99": "Cl. Institucionales", "01": "Planta de Cogeneración" };
  }
  if (society === "00J9") {
    return { "90": "Gestión Centralizada" };
  }
  if (society === "00K3") {
    return { "01": "Planta de Cogeneración" };
  }
  if (society === "00K8") {
    return { "90": "Gestión Centralizada" };
  }
  if (society === "00L6") {
    return {
      "01": "Crudos",
      "02": "Productos",
      "03": "Transportes",
      "04": "Demoras",
      "05": "Intermediación y Cobertura",
      "06": "Financiero",
      "07": "Servicios",
      "91": "Gestión Centralizada"
    };
  }
  if (society === "00L9") {
    return { "01": "Segeper SA" };
  }
  if (society === "00S0") {
    return { "91": "Gestión Centralizada", CG: "Consignaciones" };
  }
  if (society === "00R1") {
    return { "90": "Gestión Centralizada" };
  }
  if (society === "0012") {
    return {
      "01": "Noroeste",
      "02": "Norte",
      "03": "Aragón",
      "04": "Levante",
      "05": "Andalucía",
      "06": "Cataluña",
      "07": "Centro Norte/Baleares",
      "08": "Centro Oeste/Canarias",
      "09": "Hosteleria",
      "10": "no se usa 10",
      "11": "no se usa 11",
      "13": "no se usa 13",
      "21": "Clientes Área Industrial",
      "22": "Propietarios EE.SS.",
      "23": "Subarrendatarios",
      "32": "Noreste",
      "33": "Centro",
      "34": "Sur",
      "35": "Puertos Pesqueros",
      "91": "Gestión Centralizada"
    };
  }
  return {};
};
export const claimingArea2Sap = society => {
  if (society === "0012") {
    return {
      Noroeste: "01",
      Norte: "02",
      Aragón: "03",
      Levante: "04",
      Andalucía: "05",
      Cataluña: "06",
      "Centro Norte/Baleares": "07",
      "Centro Oeste/Canarias": "08",
      Hosteleria: "09",
      "no se usa 10": "10",
      "no se usa 11": "11",
      "no se usa 13": "13",
      "Clientes Área Industrial": "21",
      "Propietarios EE.SS.": "22",
      Subarrendatarios: "23",
      Noreste: "32",
      Centro: "33",
      Sur: "34",
      "Puertos Pesqueros": "35",
      "Gestión Centralizada": "91"
    };
  }
  if (society === "1024") {
    return {
      "ATL Levante-Lubricantes": "00",
      "ATL-Centro": "01",
      "ATL-Galicia": "02",
      "ATL-Asturias": "03",
      "ATL-Santander": "04",
      "ATL-Bilbao": "05",
      "ATL-Andalucia-Oriental": "06",
      "PUERTO MARÍN": "07",
      "PUERTO DENIA": "08",
      "PUERTO JAVEA": "09",
      "PUERTO ALICANTE": "10",
      "ATL Cataluña-Lubricantes": "11",
      "PUERTO CULLERA": "12",
      "PUERTO ADRA": "13",
      "PUERTO ROQUETAS DE MAR": "14",
      "PUERTO AYAMONTE": "15",
      "PUERTO HUELVA": "16",
      "PUERTO ESTEPONA": "17",
      "PUERTO MARBELLA": "18",
      "PUERTO BARBATE": "19",
      "PUERTO CADIZ": "20",
      "PUERTO SANLUCAR DE BARRAMEDA": "21",
      "P.P.ISLA CRISTINA": "22",
      "P.P.PUNTA UMBRIA": "23",
      "P.P.CONIL": "24",
      "P.P.TARIFA": "25",
      "P.P.ALGECIRAS": "26",
      "P.P.LA LINEA DE LA CONCEPCIÓN": "27",
      "P.P.EL SALADILLO": "28",
      "P.P.MALAGA": "29",
      "P.P.MOTRIL": "30",
      "P.P.ALMERIA": "31",
      "P.P.SAN PEDRO DEL PINATAR": "32",
      "P.P.TORREVIEJA": "33",
      "P.P.SANTA POLA": "34",
      "P.P.CALPE": "35",
      "P.P.MORAIRA": "36",
      "P.P.BARCELONA": "37",
      "ATL Andalucia Occidental": "38",
      "ATL Jaén": "39",
      "ATL Gestión Centralizada": "40",
      "P/P EXPLOTACIÓN": "43",
      "P/P GESTORES AJENOS": "44",
      "P.P. de POLLENSA": "45",
      "P.PUERTO DE.SANTA MARIA 2": "46",
      "P.P. Castellón": "47",
      "P.P.Barbate": "48",
      "P.P. ALMERIA": "49",
      Canarias: "51",
      "Deudores no comerciales": "71",
      "Gestión Centralizada PP": "90",
      "Gestión Centralizada": "91",
      COMA: "99",
      "Postes Pesca": "B0",
      "CGL ENVASADO CENTRO": "B1",
      "CGL ENVASADO LEVANTE": "B2",
      "CGL ENVASADO SUR": "B3",
      "CGL ENVASADO NORTE": "B4",
      "Envasado Canarias": "B5",
      Bilbao: "BI",
      "CGL Levante (Canalizado)": "C0",
      "CGL Centro (Canalizado)": "C1",
      "CGL Castilla/León (Canalizado)": "C2",
      "CGL Malaga (Canalizado)": "C3",
      "CGL Granada (Canalizado)": "C4",
      "CGL Sur (Canalizado)": "C5",
      "CGL Norte (Canalizado)": "C6",
      "CGL Cataluña (Canalizado)": "C7",
      "CGL Aragón (Canalizado)": "C8",
      "CGL Centro/Norte (Canalizado)": "C9",
      "CGL Noroeste (Canalizado)": "CA",
      "Clientes Institucionales": "CI",
      "Centro-Norte": "CN",
      "Centro-Sur": "CS",
      "EESS CENTRALIZADA": "E0",
      "EESS NORTE": "E1",
      "EESS ESTE": "E2",
      "EESS CENTRO": "E3",
      "EESS SUR": "E4",
      "EESS NOROESTE": "E5",
      "EESS CANARIAS": "E6",
      Exportaciones: "EX",
      "CGL GESTION CENTRALIZADA": "G0",
      "CGL GRANEL CENTRO": "G1",
      "CGL GRANEL LEVANTE": "G2",
      "CGL GRANEL SUR": "G3",
      "CGL GRANEL NORTE": "G4",
      "CGL GRANEL CANARIAS": "G5",
      Gijon: "GI",
      "LUBES ATLﾁNTICO": "L0",
      "LUB GENERAL: Gestion Centralizada": "L1",
      "LUB EXPORTACION": "L2",
      "LUB BASES": "L3",
      "LUB ESTACIONES DE SERVICIO": "L4",
      "LUB PARAFINAS": "L5",
      "LUB EXPORTACION PORTUGAL": "L6",
      "LUB CANARIAS ( Disa)": "L7",
      "LUB DISTRIB. CEPSA": "L8",
      "LUB BP": "L9",
      "LUB MARINOS: Levante": "LA",
      "LUB MARINOS: Noroeste": "LB",
      "LUB MARINOS: Canarias": "LC",
      "LUB MARINOS: Norte": "LD",
      "LUB MARINOS: Centralizados": "LE",
      "LUB MARINOS: Sur": "LF",
      "LUB MARINOS: Exxon": "LG",
      "LUB P.FLOTAS: Este": "LH",
      "LUB P.FLOTAS: Centro": "LI",
      "LUB P.FLOTAS: Norte": "LJ",
      "LUB P.FLOTAS: Centralizados": "LK",
      "LUB P.INDUSTRIA: Este": "LM",
      "LUB P.INDUSTRIA: Centro": "LN",
      "LUB P.INDUSTRIA: Norte": "LO",
      "LUB P.INDUSTRIA: Centralizados": "LP",
      "LUB GRANDES SUPERFICIES": "LQ",
      "LUB CONSUMO": "LR",
      "LUB RESTO CONSUMO": "LS",
      "LUB MARCAS TERCERAS": "LT",
      "LUB CHEVRON": "LU",
      "LUB CARGA INICIAL CHEVRON": "LV",
      Madrid: "MA",
      Motril: "MO",
      Noreste: "NE",
      Norte: "NO",
      "P.P CENTRAL MADRID": "P1",
      "PUERTO STA. MARIA": "P2",
      "PUERTO VINAROZ": "P3",
      "PUERTO GIJON": "P4",
      "PUERTO BERBES": "P5",
      "FACTORIA GUIXAR": "P6",
      "PUERTO SAGUNTO": "P7",
      "bunker canarias": "P8",
      "bunker sur": "P9",
      "bunker este": "PA",
      "bunker norte": "PB",
      "Bunker centralizada": "PC",
      "Aldesa-Torrevieja": "PD",
      Sevilla: "SE",
      Sur: "SU",
      Tarragona: "TA",
      Valencia: "VA",
      "Ventas Directas Centralizadas": "VD"
    };
  }
  if (society === "0001") {
    return {
      "Químicos Gestión Plastificantes": "01",
      "Químicos Este": "02",
      "Químicos Centro": "03",
      "Químicos Portugal": "04",
      "Químicos Noreste": "05",
      "Químicos Centralizados": "06",
      "Químicos Norte": "07",
      "Químicos; Huelva Nacional": "08",
      "Químicos; Huelva Exportación": "09",
      "10 Ventas": "10",
      "11 Bunker Tenerife": "11",
      "12 Bunker Sur": "12",
      "13 Bunker Este": "13",
      "14 Bunker Noroeste": "14",
      "15 Bunker Norte": "15",
      "16 Bunker Las Palmas": "16",
      "17 Bunker Centralizados": "17",
      "18 Bunker Suroeste": "18",
      "19 Bunker Postes Pesca": "19",
      "20 Bunker Ventas Directas": "20",
      "21 Bunker Gibraltar": "21",
      "22 Gibraltar": "22",
      "23 Gestión Centralizada": "23",
      "24 VD-REVENDEDORES-SUR": "24",
      "25 VD-REVENDEDORES-ESTE": "25",
      "26 VD-REVENDEDORES-NOROESTE": "26",
      "27 VD-REVENDEDORES-CENTRO": "27",
      "28 VD-REVENDEDORES-NORTE": "28",
      "29 VD-REVENDEDORES-NORESTE": "29",
      "30 VD-VALES COMBUSTIBLE": "30",
      "31 VD-CANARIAS": "31",
      "32 VD-CD-CEUTA/MELILLA": "32",
      "33 VD-EXPORTACIONES": "33",
      "34 EN-EXPORTACIONES": "34",
      "35 VD-CLIENTES DIRECTOS-SUR": "35",
      "36 VD-FILIALES": "36",
      "37 VD-GRANDES CLIENTES ESTRATÉGICOS": "37",
      "38 VD-CLIENTES DIRECTOS-ESTE": "38",
      "39 VD-CLIENTES DIRECTOS-NOROESTE": "39",
      "40 VD-CLIENTES DIRECTOS-CENTRO": "40",
      "41 VD-CLIENTES DIRECTOS-NORTE": "41",
      "42 VD-CLIENTES DIRECTOS-NORESTE": "42",
      "43 VD-OTRAS FILIALES": "43",
      "44 VD-CLIENTES DIRECTOS-ÁREAS FILIALES": "44",
      "45 VD-OPERADORES": "45",
      "46 VD-REVENDEDORES-ÁREAS FILIALES": "46",
      "47 EN-OPER.LOGÍSTICAS / INTERCAMBIOS": "47",
      "48 EN-ASFALTOS": "48",
      "49 EX-LUBRICANTES": "49",
      "Incidencias Distribución": "50",
      "Aviación General": "51",
      "Aviación Líneas": "52",
      "Aviación Militar": "53",
      "Aviación Petrolíferas": "54",
      "Aviación Revendedores": "55",
      "56 VD-EE.SS.Grandes Superficies": "56",
      "57 Bunker Madrid": "57",
      "58 Bunker Canarias": "58",
      "59 Bunker Sur/BK-Algeciras": "59",
      "60 Bunker Este/BK-Barcelona": "60",
      "61 Fletes y Demoras": "61",
      "62 Bunker Este/BK-Valencia": "62",
      "63 Bunker NORTE/BK-Bilbao": "63",
      "64 Bunker NORTE/BK-Vigo": "64",
      "65 EN-DES.NEG.EXPORTACIONES": "65",
      "66 VD-CLIENTES DIRECTOS-CEUTA/MELILLA": "66",
      "67 Gestión Centralizada (PP)": "67",
      "68 VD-GRANDES CLIENTES ESTRATEGICOS-8": "68",
      "69 VD-OTRAS FILIALES-8": "69",
      "70 VD-INSTITUCIONALES CENTRALIZADOS EXPEDIENTES": "70",
      "71 VD-INSTITUCIONALES DESCENTRALIZADOS-ESTE": "71",
      "72 VD-INSTITUCIONALES DESCENTRALIZADOS-NOROESTE": "72",
      "73 VD-INSTITUCIONALES DESCENTRALIZADOS-CENTRO": "73",
      "74 VD-INSTITUCIONALES DESCENTRALIZADOS-NORTE": "74",
      "75 VD-INSTITUCIONALES CENTRALIZADOS VARIOS": "75",
      "76 VD-INSTITUCIONALES DESCENTRALIZADOS-NORESTE": "76",
      "77 VD-INSTITUCIONALES DESCENTRALIZADOS-SUR": "77",
      "78 VD-INSTITUCIONALES DESCENTRALIZADOS-FILIALES": "78",
      "Institucionales Ceuta/Melilla (NO USAR) sólo infor": "79",
      "80 VD-CLIENTES DIRECTOS-ESTRATÉGICOS CENTRALIZADOS": "80",
      "81 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-ESTE": "81",
      "82 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-NOROESTE": "82",
      "83 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-CENTRO": "83",
      "84 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-NORTE": "84",
      "85 VD-CD-Estratégicos Canarias (ex-CCL)": "85",
      "86 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-NORESTE": "86",
      "87 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-SUR": "87",
      "88 VD-CD-ESTRATÉGICOS DESCENTRALIZADOS-FILIALES": "88",
      "89 VD-REVENDEDORES ESTRATÉGICOS CENTRALIZADOS": "89",
      "90 Gestión Corporativa": "90",
      "91 Gibraltar - San Roque": "91",
      "92 Tenerife": "92",
      "93 Exploración / Producción": "93",
      "94 Huelva": "94",
      "95 VD-EE.SS.Blancas": "95",
      "Planta de Cogeneración La Rábida": "96",
      Gas: "97",
      "98 VD-OTRAS FILIALES-14": "98",
      "99 EN-OPER.LOGÍSTICAS / INTERCAMBIOS-8": "99",
      "Multiárea División 0001": "A1",
      "Multiárea División 0002": "A2",
      "Multiárea División 0003": "A3",
      "Multiárea División 0004": "A4",
      "Multiárea División 0005": "A5",
      "Multiárea División 0008": "A8",
      "Multiárea División 0009": "A9",
      "Multiárea División 1100": "AC",
      "Multiárea División 0201": "AE",
      "Multiárea División 0101": "AP",
      "Postes Pesca": "B0",
      "B1 VD Exportaciones-8": "B1",
      "B2 EN-EXPORTACIONES-8": "B2",
      "B3 EN-ASFALTOS-7": "B3",
      "Doméstico Zona Centro": "B4",
      "Industria Zona Centro": "B5",
      "Administraciones Públicas Zona Centro": "B6",
      "Transporte Zona Centro": "B7",
      "Agrícola Zona Centro": "B8",
      "Descentralizados Filiales Zona Centro": "B9",
      lubrisur: "C0",
      "VD - Doméstico Zona Noreste": "C4",
      "VD - Industria Zona Noreste": "C5",
      "VD - Administraciones Públicas Zona Noreste": "C6",
      "VD - Transporte Zona Noreste": "C7",
      "VD - Agrícola Zona Noreste": "C8",
      "VD - Descentralizados Filiales Zona Noreste": "C9",
      Consignaciones: "CG",
      "VD - Doméstico Zona Norte": "D4",
      "VD - Industria Zona Norte": "D5",
      "VD - Administraciones Públicas Zona Norte": "D6",
      "VD - Transporte Zona Norte": "D7",
      "VD - Agrícola Zona Norte": "D8",
      "VD - Descentralizados Filiales Zona Norte": "D9",
      "VD - Doméstico Zona Sur": "E4",
      "VD - Industria Zona Sur": "E5",
      "VD - Administraciones Públicas Zona Sur": "E6",
      "VD - Transporte Zona Sur": "E7",
      "VD - Agrícola Zona Sur": "E8",
      "VD - Descentralizados Filiales Zona Sur": "E9",
      Trading: "F1",
      "Cepsa Gibraltar": "G1",
      "RED AAPP": "R0",
      "Ressa Zona Sur": "R1",
      "Ressa Zona Centro": "R2",
      "Ressa Centralizados": "R3",
      "Ressa Retail": "R4",
      "Ressa Zona Este": "R5",
      "Ressa Zona Noreste": "R6",
      "Ressa Zona Noroeste": "R7",
      "Ressa Zona Centro Norte": "R8",
      "EEBB D1": "Y1",
      "EEBB D6": "Y2",
      "EEBB D7": "Y3",
      "EEBB D9": "Y4",
      EEBB_DH: "Y5",
      "Energetico-BIO": "Z1",
      "TRANSPORTE ZONA SUR": "T1",
      "TRANSPORTE ZONA CENTRO": "T2",
      "TRANSPORTE ZONA NOROESTE": "T3",
      "TRANSPORTE ZONA ESTE": "T4",
      "TRANSPORTE CENTRALIZADOS": "T5"
    };
  }
  if (society === "00D7") {
    return {
      Domiciliados: "01",
      "AA.PP y similares": "02",
      "Clientes Estratégicos": "03",
      SECTRAM: "04",
      "Otros Emisores (Eurotrafic, Routex,...) ": "05",
      "Otros Suministradores (CPP, CEPSA, CES, ...)": "06",
      "Estaciones y otros Establecimientos (autopistas,.)": "07",
      Portugal: "08",
      "Clientes Pan Europe": "20",
      "Clientes NO Recibo Domiciliado": "21",
      "Clientes Devoluciones": "22",
      "Otros Clientes": "23",
      "Gestión Centralizada": "90"
    };
  }
  if (society === "00Q8") {
    return {
      España: "01",
      Este: "02",
      "sin usoant. Quimica Centro": "03",
      Noreste: "04",
      Norte: "05",
      "Europa comunitario": "10",
      Portugal: "11",
      Holanda: "12",
      "Reino Unido": "13",
      Exportación: "20",
      "sin usoant. Quimica Otros": "40",
      "Operaciones NO comerciales": "50"
    };
  }
  if (society === "0006") {
    return { "Gestión Centralizada": "90" };
  }
  if (society === "0009") {
    return { "Gestión Centralizada": "90" };
  }
  if (society === "0011") {
    return { "Gestión Centralizada": "90", Bio: "B1" };
  }
  if (society === "0021") {
    return { "Gestión Centralizada": "90" };
  }
  if (society === "0025") {
    return { "Gestión Centralizada": "90" };
  }
  if (society === "0032") {
    return { "Gestión Centralizada": "90" };
  }
  if (society === "0036") {
    return { "Gestión Centralizada": "90" };
  }
  if (society === "0050") {
    return { "Gestión Centralizada": "90" };
  }
  if (society === "0051") {
    return { "": "" };
  }
  if (society === "0093") {
    return {
      Comercializadora: "01",
      "Gas Natural": "02",
      "Agente A": "03",
      "Agente B": "04",
      "Agente C": "05",
      "CODO-DODO": "06",
      "Comerc. Portugal": "11",
      Trading: "98",
      "Cl. Institucionales": "99"
    };
  }
  if (society === "00H6") {
    return { "Planta de Cogeneración": "01", "Cl. Institucionales": "99" };
  }
  if (society === "00J9") {
    return { "Gestión Centralizada": "90" };
  }
  if (society === "00K3") {
    return { "Planta de Cogeneración": "01" };
  }
  if (society === "00K8") {
    return { "Gestión Centralizada": "90" };
  }
  if (society === "00L6") {
    return {
      Crudos: "01",
      Productos: "02",
      Transportes: "03",
      Demoras: "04",
      "Intermediación y Cobertura": "05",
      Financiero: "06",
      Servicios: "07",
      "Gestión Centralizada": "91"
    };
  }
  if (society === "00L9") {
    return { "Segeper SA": "01" };
  }
  if (society === "00S0") {
    return { "Gestión Centralizada": "91", Consignaciones: "CG" };
  }
  if (society === "00R1") {
    return { "Gestión Centralizada": "90" };
  }
  return {};
};

export default {
  sap2Society,
  society2Sap,

  sap2Division,
  division2Sap,

  sap2AccountingKey,
  accountingKey2Sap,

  accountingKeySign,

  sap2ClaimingArea,
  claimingArea2Sap
};
